<template>
  <div class="PcReport">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div style="width: 100vw">
          <b-row class="mx-0 mb-3">
            <b-col
              cols="12"
              class="p-0 m-0 mt-4 mb-2"
              style="font-size: 1.75rem; color: #000000"
            >
              <span class="m-auto">生管報表</span>
            </b-col>
            <b-col cols="12">
              <iframe
                title="生管報表(機力)"
                width="1440"
                height="850"
                src="https://app.powerbi.com/view?r=eyJrIjoiODQ1NGRmMDMtM2E4ZC00YTcxLWI1OGYtNzQzNGIzMGUzZWNiIiwidCI6IjZjMzViZjAyLTFhY2MtNDE5Mi1iNmFhLWExYTRjNTRiNjZkZCIsImMiOjEwfQ%3D%3D"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PcReport",
  data() {
    return {};
  },
  created: function() {
    let vm = this;
    vm.change_selectPage("pcreport");
    vm.change_selectPageName(vm.pageName.pcreport);
  },
  mounted: function() {},
  components: {},
  watch: {},
  computed: {
    ...mapGetters({
      pageName: "getlogin/get_pageName"
    })
  },
  methods: {
    ...mapActions({
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName"
    })
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/PcReport.vue